// extracted by mini-css-extract-plugin
export default {"create-button":"_3LDaw","createButton":"_3LDaw","get-core":"_1BEl-","getCore":"_1BEl-"};